<template>
  <div class="collapse-container">
    <div class="collapse-title"></div>
    <div class="collapse-item" v-for="(item, index) in panels" :key="item.id">
      <div class="collapse-header" @click="togglePanel(index)">
        <div class="header-title">
          <div class="index">
            <img v-if="index+1==1" src="https://pgcloud.aitici.com/common/20250730/33f1e4e9044c461b868d51a60ab0fd58.png">
            <img v-if="index+1==2" src="https://pgcloud.aitici.com/common/20250730/f0bdb7c02def4c9487ac375a5b1478bf.png">
            <img v-if="index+1==3" src="https://pgcloud.aitici.com/common/20250730/27a1f960020045149740f283b6f8d876.png">
            <img v-if="index+1==4" src="https://pgcloud.aitici.com/common/20250730/c4843b56191b46a0a4a3168a259c7d24.png">
            <img v-if="index+1==5" src="https://pgcloud.aitici.com/common/20250730/e38a8dc5f7be48739057ac60795d5847.png">
          </div>
          <div class="text">
            {{ item.title }}
          </div>
        </div>
        <div class="header-icon">
          <img :class="{ 'rotate': item.expanded }" src="https://pgcloud.aitici.com/common/20250807/43e67d129d1745b79b68e3e6391e7efa.png">
        </div>
      </div>

      <div class="collapse-content" :style="{ height: item.expanded ? item.height + 'px' : '0px' }">
        <!-- 首页 -->
        <div class="a-box" :ref="'box'+index" v-if="type=='index'&&index+1==1">
          <div class="placeholder"></div>
          提交一键退款申请后，系统将会为您极速退款，同时将会取消会员服务，后续将不会再次扣款。为避免退款失败，申请退款后无需进行其他任何操作。
        </div>
        <div class="a-box" :ref="'box'+index" v-if="type=='index'&&index+1==2">
          <div class="placeholder"></div>
          您在购买会员服务时已签约自动续费协议，根据协议内容，会员到期后会进行自动续费。如您不再需要此项服务，可在下方自助退款，后续不会再扣费。
        </div>
        <div class="a-box" :ref="'box'+index" v-if="type=='index'&&index+1==3">
          <div class="placeholder"></div>
          关闭自动续费/免密支付后，协议即失效，失效后商家无法进行扣款。您可在下方自助退款，将关闭协议，后续不会再扣费。
        </div>
        <div class="a-box" :ref="'box'+index" v-if="type=='index'&&index+1==4">
          <div class="placeholder"></div>
          您可以随时拨打客服热线{{mobileWithHyphen}}，7*24小时为您服务。或点击下方人工客服按钮，可快速拨打客服电话。
        </div>
        <div class="a-box" :ref="'box'+index" v-if="type=='index'&&index+1==5">
          <div class="placeholder"></div>
          打开支付宝App-我的-（右上角）设置-支付设置-自动续费/免密支付，页面上方可以选择不同的协议类型（自动续费/先用后付/免密支付）。
        </div>

        <!-- 退款成功页 -->
        <div class="a-box" :ref="'box'+index" v-if="type=='result'&&index+1==1">
          <div class="placeholder"></div>
          您提交一键退款申请时，系统已为您关闭自动扣款，后续不会再次扣款，您无需做其他任何操作。
        </div>
        <div class="a-box" :ref="'box'+index" v-if="type=='result'&&index+1==2">
          <div class="placeholder"></div>
          您之前购买过我们的会员服务，同时签约了自动续费的协议，开通了会员自动续费服务，所以会员到期可以根据协议内容进行自动扣费，无需再次输入密码。<span>目前这个扣款协议已取消成功，后续不会再扣费。</span>
        </div>
        <div class="a-box" :ref="'box'+index" v-if="type=='result'&&index+1==3">
          <div class="placeholder"></div>
          关闭自动续费/免费支付后，协议即失效，失效后商家无法进行扣款。<span>目前您已解除与本商家的自动扣款协议，不会再自动扣费。</span>
        </div>
        <div class="a-box" :ref="'box'+index" v-if="type=='result'&&index+1==4">
          <div class="placeholder"></div>
          您可以随时拨打商家客服热线{{mobileWithHyphen}}，7*24小时为您服务。点击页面下方按钮，可快速拨打客服电话。
        </div>
        <div class="a-box" :ref="'box'+index" v-if="type=='result'&&index+1==5">
          <div class="placeholder"></div>
          您可以通过以下路径进行查询：<br />
          打开支付宝App-我的-（右上角）设置-支付设置-自动续费/免密支付，页面上方可以选择不同的协议类型（自动续费/先用后付/免密支付）。<br />
          如图所示：
          <img @click="preview()" src="https://pgcloud.aitici.com/common/20250730/5e26be478a684582b2d72270c8c6748b.png">
          <span>您已经取消与此商家的自动扣款协议，后续不会产生扣费。如有问题，请点击页面下方按钮联系客服，我们将极速为您解决。</span>
        </div>

      </div>
      <div class="collapse-foot" v-if="index!=4"></div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  name: "Collapse",
  props: {
    type: {
      type: String,
      default: "index",
    },
  },
  data() {
    return {
      mobileWithHyphen: "400-765-8113",
      panels: [
        {
          id: "panel1",
          title: "如何关闭自动扣款",
          height: 0,
          expanded: false,
        },
        {
          id: "panel2",
          title: "为什么被扣款",
          height: 0,
          expanded: false,
        },
        {
          id: "panel3",
          title: "关闭免密支付/自动扣款后还会扣费吗",
          height: 0,
          expanded: false,
        },
        {
          id: "panel4",
          title: "怎么联系商家",
          height: 0,
          expanded: false,
        },
        {
          id: "panel5",
          title: "怎么查询免密支付/自动扣款协议",
          height: 0,
          expanded: false,
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 初始测量内容高度
      this.getBoxHeight();
    });
  },
  methods: {
    // 预览图片
    preview() {
      ImagePreview({
        images: [
          "https://pgcloud.aitici.com/common/20250730/5e26be478a684582b2d72270c8c6748b.png",
        ],
        startPosition: 0,
        showIndex: false,
      });
    },
    togglePanel(index) {
      this.panels.forEach((panelsItem, panelsIndex) => {
        if (panelsIndex == index) {
          panelsItem.expanded = !panelsItem.expanded;
        } else {
          panelsItem.expanded = false;
        }
      });
    },
    getBoxHeight() {
      this.panels.forEach((item, index) => {
        const el = this.$refs["box" + index];
        if (el) {
          item.height = el[0].offsetHeight;
        } else {
          item.height = 0;
        }
      });
    },
  },
};
</script>

<style lang="less">
/* 关键样式：修改预览图宽度为屏幕宽度 */
.van-image-preview__image {
  width: 100vw !important;
  height: auto !important;
  object-fit: contain; /* 保持宽高比 */
}
</style>

<style lang="less" scoped>
.collapse-container {
  width: 702px;
  padding: 40px 36px 40px 24px;
  margin: auto;
  background: #ffffff;
  border-radius: 30px 30px 30px 30px;
}

.collapse-title {
  width: 240px;
  height: 58px;
  margin-bottom: 24px;
  background-image: url("https://pgcloud.aitici.com/common/20250807/315d84cdd6f84b81ae05172d263ce133.png");
  background-size: 100% 100%;
}

.collapse-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;

  .header-title {
    display: flex;
    align-items: center;
    height: 40px;

    .index {
      width: 32px;
      height: 40px;
      margin-right: 8px;
    }

    .text {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #130d3b;
      line-height: 40px;
    }
  }

  .header-icon {
    width: 32px;
    height: 32px;

    img {
      transition: transform 0.3s ease;
    }

    .rotate {
      transform: rotate(-180deg);
    }
  }
}

.collapse-content {
  width: 614px;
  margin-left: 40px;

  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 26px;
  color: #3D395E;
  line-height: 40px;

  height: 0;
  overflow: hidden;
  transition: height 0.3s ease;

  .placeholder {
    height: 20px;
  }

  // span {
    // color: #130d3b;
    // font-weight: bold;
  //}

  img {
    width: 614px;
    height: 306px;
    margin: 20px 0;
  }
}

.collapse-foot {
  width: 614px;
  height: 2px;
  margin-top: 24px;
  margin-left: 40px;
  margin-bottom: 24px;
  background-color: #eeeeee;
}
</style>